import { render, staticRenderFns } from "./SeminarEntry.vue?vue&type=template&id=76bab60f"
import script from "./SeminarEntry.vue?vue&type=script&lang=js"
export * from "./SeminarEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports